// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TextFieldInline Component Styles
   Same visual language as TextField — no floating label, placeholder only.
*/

:root {
  --scl--cms-components-textFieldInline-border-color:       var(--input-defualt);
  --scl--cms-components-textFieldInline-border-hover-color: var(--input-hover);
  --scl--cms-components-textFieldInline-focus-color:        #2388FF;
  --scl--cms-components-textFieldInline-warning-color:      #FFC18E;
  --scl--cms-components-textFieldInline-error-color:        #F8868A;
  --scl--cms-components-textFieldInline-text-color:         var(--input-hover);
  --scl--cms-components-textFieldInline-placeholder-color:  var(--input-defualt);
  --scl--cms-components-textFieldInline-required-color:     #EB5252;
  --scl--cms-components-textFieldInline-assistive-color:    rgba(255, 255, 255, 0.54);
  --scl--cms-components-textFieldInline-assistive-error:    #FF5252;
  --scl--cms-components-textFieldInline-assistive-warning:  #FFC18E;
}

/* ─── Container ──────────────────────────────────────────────────────────────── */

.scl--cms-components-textFieldInline-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  position: relative;
}

/* ─── Plate ──────────────────────────────────────────────────────────────────── */

.scl--cms-components-textFieldInline-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  border: 1px solid var(--scl--cms-components-textFieldInline-border-color);
  border-radius: 3px;
  cursor: text;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  background: transparent;
}

/* Single-line height */
.scl--cms-components-textFieldInline-plate:not(.scl--cms-components-textFieldInline--multiline) {
  height: 38px;
}

/* Multi-line */
.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--multiline {
  min-height: 80px;
  height: auto;
  align-items: stretch;
  cursor: text;
}

/* Bottom focus accent bar */
.scl--cms-components-textFieldInline-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background: var(--scl--cms-components-textFieldInline-focus-color);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--focused::after {
  opacity: 1;
}

/* Hover */
.scl--cms-components-textFieldInline-plate:hover:not(.scl--cms-components-textFieldInline--focused) {
  border-color: var(--scl--cms-components-textFieldInline-border-hover-color);
}

/* Focused */
.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--focused {
  border-color: var(--scl--cms-components-textFieldInline-border-hover-color);
}

/* Warning */
.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--warning::after {
  background: var(--scl--cms-components-textFieldInline-warning-color);
  opacity: 1;
}

/* Error */
.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--error::after {
  background: var(--scl--cms-components-textFieldInline-error-color);
  opacity: 1;
}

/* Disabled */
.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── Inner wrapper ───────────────────────────────────────────────────────────── */

.scl--cms-components-textFieldInline-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 12px;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  order: 0;
  flex-grow: 1;
}

.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--multiline
.scl--cms-components-textFieldInline-wrapper {
  align-items: flex-start;
  padding: 8px 12px;
}

/* ─── Input ──────────────────────────────────────────────────────────────────── */

.scl--cms-components-textFieldInline-input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  caret-color: var(--input-hover);
  color: var(--scl--cms-components-textFieldInline-text-color);
  padding: 0;
  flex: 1;
  order: 0;
  flex-grow: 1;
  min-height: 38px;
  box-sizing: border-box;
}

/* Textarea */
.scl--cms-components-textFieldInline-input.scl--cms-components-textFieldInline-input--textarea {
  resize: vertical;
  min-height: 64px;
  line-height: 22px;
  padding-top: 2px;
}

/* Placeholder — visible by default (no label to animate from) */
.scl--cms-components-textFieldInline-input::placeholder {
  color: var(--scl--cms-components-textFieldInline-placeholder-color);
  opacity: 1;
}

.scl--cms-components-textFieldInline-input:disabled {
  cursor: not-allowed;
}

/* ─── Assistive / Error / Warning text ───────────────────────────────────────── */

.scl--cms-components-textFieldInline-assistive {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 4px 0 14px;
  min-height: 16px;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: var(--scl--cms-components-textFieldInline-assistive-color);
  width: 100%;
  box-sizing: border-box;
}

.scl--cms-components-textFieldInline-assistive.scl--cms-components-textFieldInline-assistive--error {
  color: var(--scl--cms-components-textFieldInline-assistive-error);
}

.scl--cms-components-textFieldInline-assistive.scl--cms-components-textFieldInline-assistive--warning {
  color: var(--scl--cms-components-textFieldInline-assistive-warning);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/input-fs-cp/text-field-op/css/textFieldInline.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,8EAA8E;EAC9E,4EAA4E;EAC5E,iEAAiE;EACjE,iEAAiE;EACjE,iEAAiE;EACjE,4EAA4E;EAC5E,8EAA8E;EAC9E,iEAAiE;EACjE,mFAAmF;EACnF,iEAAiE;EACjE,iEAAiE;AACnE;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mFAAmF;;AAEnF;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,yEAAyE;EACzE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,kEAAkE;EAClE,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,2EAA2E;AAC7E;;AAEA,YAAY;AACZ;EACE,2EAA2E;AAC7E;;AAEA,YAAY;AACZ;EACE,oEAAoE;EACpE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,kEAAkE;EAClE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oFAAoF;;AAEpF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,mFAAmF;;AAEnF;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,4DAA4D;EAC5D,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,mEAAmE;EACnE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,iEAAiE;EACjE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,mEAAmE;AACrE","sourcesContent":["/* TextFieldInline Component Styles\n   Same visual language as TextField — no floating label, placeholder only.\n*/\n\n:root {\n  --scl--cms-components-textFieldInline-border-color:       var(--input-defualt);\n  --scl--cms-components-textFieldInline-border-hover-color: var(--input-hover);\n  --scl--cms-components-textFieldInline-focus-color:        #2388FF;\n  --scl--cms-components-textFieldInline-warning-color:      #FFC18E;\n  --scl--cms-components-textFieldInline-error-color:        #F8868A;\n  --scl--cms-components-textFieldInline-text-color:         var(--input-hover);\n  --scl--cms-components-textFieldInline-placeholder-color:  var(--input-defualt);\n  --scl--cms-components-textFieldInline-required-color:     #EB5252;\n  --scl--cms-components-textFieldInline-assistive-color:    rgba(255, 255, 255, 0.54);\n  --scl--cms-components-textFieldInline-assistive-error:    #FF5252;\n  --scl--cms-components-textFieldInline-assistive-warning:  #FFC18E;\n}\n\n/* ─── Container ──────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-textFieldInline-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  position: relative;\n}\n\n/* ─── Plate ──────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-textFieldInline-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  border: 1px solid var(--scl--cms-components-textFieldInline-border-color);\n  border-radius: 3px;\n  cursor: text;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  background: transparent;\n}\n\n/* Single-line height */\n.scl--cms-components-textFieldInline-plate:not(.scl--cms-components-textFieldInline--multiline) {\n  height: 38px;\n}\n\n/* Multi-line */\n.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--multiline {\n  min-height: 80px;\n  height: auto;\n  align-items: stretch;\n  cursor: text;\n}\n\n/* Bottom focus accent bar */\n.scl--cms-components-textFieldInline-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  background: var(--scl--cms-components-textFieldInline-focus-color);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--focused::after {\n  opacity: 1;\n}\n\n/* Hover */\n.scl--cms-components-textFieldInline-plate:hover:not(.scl--cms-components-textFieldInline--focused) {\n  border-color: var(--scl--cms-components-textFieldInline-border-hover-color);\n}\n\n/* Focused */\n.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--focused {\n  border-color: var(--scl--cms-components-textFieldInline-border-hover-color);\n}\n\n/* Warning */\n.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--warning::after {\n  background: var(--scl--cms-components-textFieldInline-warning-color);\n  opacity: 1;\n}\n\n/* Error */\n.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--error::after {\n  background: var(--scl--cms-components-textFieldInline-error-color);\n  opacity: 1;\n}\n\n/* Disabled */\n.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ─── Inner wrapper ───────────────────────────────────────────────────────────── */\n\n.scl--cms-components-textFieldInline-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 12px;\n  gap: 8px;\n  width: 100%;\n  box-sizing: border-box;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n}\n\n.scl--cms-components-textFieldInline-plate.scl--cms-components-textFieldInline--multiline\n.scl--cms-components-textFieldInline-wrapper {\n  align-items: flex-start;\n  padding: 8px 12px;\n}\n\n/* ─── Input ──────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-textFieldInline-input {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  caret-color: var(--input-hover);\n  color: var(--scl--cms-components-textFieldInline-text-color);\n  padding: 0;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  min-height: 38px;\n  box-sizing: border-box;\n}\n\n/* Textarea */\n.scl--cms-components-textFieldInline-input.scl--cms-components-textFieldInline-input--textarea {\n  resize: vertical;\n  min-height: 64px;\n  line-height: 22px;\n  padding-top: 2px;\n}\n\n/* Placeholder — visible by default (no label to animate from) */\n.scl--cms-components-textFieldInline-input::placeholder {\n  color: var(--scl--cms-components-textFieldInline-placeholder-color);\n  opacity: 1;\n}\n\n.scl--cms-components-textFieldInline-input:disabled {\n  cursor: not-allowed;\n}\n\n/* ─── Assistive / Error / Warning text ───────────────────────────────────────── */\n\n.scl--cms-components-textFieldInline-assistive {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 4px 0 14px;\n  min-height: 16px;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: var(--scl--cms-components-textFieldInline-assistive-color);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-textFieldInline-assistive.scl--cms-components-textFieldInline-assistive--error {\n  color: var(--scl--cms-components-textFieldInline-assistive-error);\n}\n\n.scl--cms-components-textFieldInline-assistive.scl--cms-components-textFieldInline-assistive--warning {\n  color: var(--scl--cms-components-textFieldInline-assistive-warning);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
